/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckApiWorkingCommand } from '../../models/check-api-working-command';
import { StringApiResponse } from '../../models/string-api-response';

export interface CheckApiWorkingAsync$Plain$Params {
  command?: CheckApiWorkingCommand;
}

export function checkApiWorkingAsync$Plain(http: HttpClient, rootUrl: string, params?: CheckApiWorkingAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiResponse>> {
  const rb = new RequestBuilder(rootUrl, checkApiWorkingAsync$Plain.PATH, 'get');
  if (params) {
    rb.query('command', params.command, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StringApiResponse>;
    })
  );
}

checkApiWorkingAsync$Plain.PATH = '/api/health-check';
